import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, first, map } from 'rxjs';
import { AuthService } from '../data/auth.service';
import { environment } from '../../../environments/environment';
import { DataSource } from '../../../environments/environment.config';

export const authGuard: CanActivateFn = () => {
  if (environment.dataSource === DataSource.Mock) {
    return true;
  }

  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.loading()) {
    return authService.isAuthenticated() || router.createUrlTree(['/login']);
  }

  return toObservable(authService.loading).pipe(
    filter((loading) => !loading),
    first(),
    map(() =>
      authService.isAuthenticated() || router.createUrlTree(['/login']),
    ),
  );
};
